// Wishlistcontext.js
import React, { createContext, useState, useContext, useEffect } from "react";

export const WishlistContext = createContext();

export const WishlistProvider = ({ children }) => {
  const [wishlistItems, setWishlistItems] = useState([]);

  // ✅ Generate a consistent unique ID
  const getUID = (product) =>
    `${product.category}-${product.id}-${product.name}`;

  const addToWishlist = (product) => {
    const uid = getUID(product);
    setWishlistItems((prev) => {
      if (prev.some((item) => getUID(item) === uid)) return prev;
      return [...prev, product];
    });
  };

  const removeFromWishlist = (product) => {
    const uid = getUID(product);
    setWishlistItems((prev) => prev.filter((item) => getUID(item) !== uid));
  };

  const isWishlisted = (product) => {
    const uid = getUID(product);
    return wishlistItems.some((item) => getUID(item) === uid);
  };

  return (
    <WishlistContext.Provider
      value={{ wishlistItems, addToWishlist, removeFromWishlist, isWishlisted }}
    >
      {children}
    </WishlistContext.Provider>
  );
};

// ✅ Custom hook for easier access
export const useWishlist = () => useContext(WishlistContext);
